import { IDocumentModel } from "./../interfaces/document-model";
import { AppSettings } from "../../app-settings";
import { prop } from "../../decorators/property";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { CaseRelationModel } from "../../desktop/models/case-relation";
import { SiblingModel } from "../../desktop/models/stage";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { DocumentRelationCollection } from "../../desktop/collections/document-relations";
import { LegislationRelationModel } from "../../desktop/models/legislation-relation";
import { StatuteOutlineModel } from "../../desktop/models/statute-outline";
import { ParallelCitationModel } from "../../desktop/models/parallel-citation";
import { PublisherModel } from "../../desktop/models/publisher";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { transient } from "aurelia-dependency-injection";
import { EURelationModel } from "./eu-relation";

@backboneModelProperties({
     urlRoot: `${AppSettings.DocumentApiUrlPrefix}document`,
     relations : [
        {
            type: Backbone.Many,
            key: "AmendedItems",
            relatedModel: LegislationRelationModel,
        }, {
            type: Backbone.Many,
            key: "AmendingItems",
            relatedModel: LegislationRelationModel,
        },
        {
            type: Backbone.Many,
            key: "CitingCases",
            relatedModel: CaseRelationModel
        }, {
            type: Backbone.One,
            key: "Outline",
            relatedModel: StatuteOutlineModel
        },
        {
            type: Backbone.Many,
            key: "Stages",
            relatedModel: SiblingModel
        },
        {
            type: Backbone.Many,
            key: "ParallelCitations",
            relatedModel: ParallelCitationModel
        },
        {
            type: Backbone.Many,
            key: "Publishers",
            relatedModel: PublisherModel
        },
        {
            type: Backbone.Many,
            key: "ImplementedEULegislation",
            relatedModel: EURelationModel
        }
    ],
    defaults: {
        Populated: false,
        Visible: false,
        Animated: false,
        Expired: false,
        Highlighting: false,
        AmendedItems: [],
        AmendingItems: [],
        CitingCases: [],
        Stages: [],
        ParallelCitations: [],
        Publishers: [],
        ImplementedEULegislation: []
    }
})
@transient()
export class LegislationDocumentModel extends BaseDocumentModel implements IDocumentModel {

    @prop() public CitingCases: Backbone.Collection<CaseRelationModel>;
    @prop() public AmendedItems: Backbone.Collection<LegislationRelationModel>;
    @prop() public AmendingItems: Backbone.Collection<LegislationRelationModel>;
    @prop() public ShowAllAmendedJurisdictions: boolean;
    @prop() public ShowAllAmendingJurisdictions: boolean;
    @prop() public IsSection: boolean;
    @prop() public EntityType: string;
    @prop() public IsLocalAct: boolean;
    @prop() public Outline: Backbone.Model;
    @prop() public DisplaySectionNumber: boolean;
    @prop() public CroppedTitle: string;
    @prop() public LatestRevisionAvailable: boolean;
    @prop() public Act: any;
    @prop() public Citation: any;

    constructor(options?) {
        super(options);
    }

    public get HasReports() {
        return false;
    }

    public getTooltipForJurisdictionShowAllButton(showOnlyMyJurisdiction: boolean): string {
        return showOnlyMyJurisdiction ? "Show only my jurisdictions" : "Show all jurisdictions";
    }

    public loadFullText(): Promise<{}> {
        return new Promise<any>((resolve, reject) => {
            if (this.FullTextLoaded) {
                resolve();
            } else {
                this.getFulltextFromServer(this.RenderType, this.Id).then((response) => {
                    this.FullText = response.Fulltext;
                    this.PdfLinks = response.PdfDetails;
                    this.FullTextLoaded = true;
                    resolve();
                });
            }
        });
    }

    public runPriorityProcess(data: any) {
        const options: any = {
            DocKeys: [data.Id],
            QueueName: "Priority"
        };
        const controllerName = this.getControllerNameFromProcess(data.processName);
        const url = AppSettings.ProcessingApiUrlPrefix + controllerName;
        if (controllerName.toLowerCase() === "patches") {
            options.Patch = data.processName;
        }
        return Promise.resolve($.ajax({
            url,
            type: "POST",
            data: options,
            success: (successData) => {
                this.appEvents.trigger(AppEvents.InformationMessage, successData);
            },
            beforeSend: AuthorizationModel.attachAuthorizationHeader
        }));
    }

    public getSectionName(): string {
        if (this.IsSection) {
            return this.DisplaySectionNumber ? this.SectionNumber + ". " + this.CroppedTitle : this.CroppedTitle;
        } else {
            return "Whole Act";
        }
    }

    private setupEventListeners(): void {
        this.appEvents.on(AppEvents.JurisdictionsSaved, () => {
            this.refresh();
            this.ShowAllAmendedJurisdictions = false;
            this.ShowAllAmendingJurisdictions = false;
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/legislation-document.ts